export enum DateFilter {
  All = 0,
  CurrentAndLast3Months = 1,
  Next6AndLast3Months = 2,
  Last6Months = 3,
  Last12Months = 4,
  Next3Monts = 5,
}
